import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

export const getChargingProfiles = createAsyncThunk('get/getChargingProfiles', async (params) => {
  const response = await axios.get('/charging-profile/', { params });
  return response.data;
});

export const getChargingProfile = createAsyncThunk('get/getChargingProfile', async (id) => {
  const response = await axios.get(`/charging-profile/${id}/`);
  return response.data;
});

export const addChargingProfile = createAsyncThunk(
  'post/addChargingProfile',
  async (chargingData, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/charging-profile/', chargingData);
      dispatch(getChargingProfiles());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateChargingProfile = createAsyncThunk(
  'put/updateChargingProfile',
  async ({ chargingID, chargingData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/charging-profile/${chargingID}/`, chargingData);
      dispatch(getChargingProfiles());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getProfileById = createAsyncThunk('get/getProfileById', async (chargingId) => {
  const response = await axios.get(`/charging-profile/${chargingId}/`);
  return response.data;
});

export const addProfile = createAsyncThunk('post/addProfile', async (params, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/charger/add_profile/', params);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const removeProfile = createAsyncThunk('delete/removeProfile', async (id, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post(`/charger/remove_profile/${id}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteChargingProfile = createAsyncThunk(
  'delete/deleteChargingProfile',
  async (chargingId, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete(`/charging-profile/${chargingId}/`);
      dispatch(getChargingProfiles());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteManyChargingProfiles = createAsyncThunk(
  'delete/deleteManyChargingProfiles',
  async (chargingIds, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete('/charging-profile/delete_many/', { data: { arrId: chargingIds } });
      dispatch(getChargingProfiles());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const chargingAdapter = createEntityAdapter({});

const chargingSlice = createSlice({
  name: 'chargingProfile',
  initialState: chargingAdapter.getInitialState({
    chargingProfiles: [],
    profile: {},
    loading: false,
    isSubmitting: false,
    openProfileTable: false,
  }),
  reducers: {
    setOpenProfileDialog(state, action) {
      state.openProfileTable = action.payload;
    },
    resetChargingProfiles: (state) => {
      state.chargingProfiles = [];
    },
  },
  extraReducers: {
    [getChargingProfiles.pending]: (state) => {
      state.loading = true;
    },
    [getChargingProfiles.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.chargingProfiles = data;
      state.loading = false;
    },
    [getChargingProfiles.rejected]: (state) => {
      state.loading = false;
    },

    // ---------------------------------------------
    [addChargingProfile.pending]: (state) => {
      state.isSubmitting = true;
    },

    [addChargingProfile.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [addChargingProfile.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------------
    [updateChargingProfile.pending]: (state) => {
      state.isSubmitting = true;
    },

    [updateChargingProfile.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [updateChargingProfile.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------------
    [deleteChargingProfile.pending]: (state) => {
      state.isSubmitting = true;
    },

    [deleteChargingProfile.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [deleteChargingProfile.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------------
    [deleteManyChargingProfiles.pending]: (state) => {
      state.isSubmitting = true;
    },

    [deleteManyChargingProfiles.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [deleteManyChargingProfiles.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------------
    [getProfileById.pending]: (state) => {
      state.loading = true;
    },
    [getProfileById.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.currentChargingProfile = data;
      state.loading = false;
    },
    [getProfileById.rejected]: (state) => {
      state.loading = false;
    },

    // ---------------------------------------------
    [addProfile.pending]: (state) => {
      state.isSubmitting = true;
    },

    [addProfile.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [addProfile.rejected]: (state) => {
      state.isSubmitting = false;
    },
  },
});

export const { resetChargingProfiles, setOpenProfileDialog } = chargingSlice.actions;

export default chargingSlice.reducer;
